import React, {Suspense} from "react";
import {Routes, Route} from "react-router-dom";

// Layouts
import Layout from "../layouts";
// import ProtectedRoute from "./protectedRoute";

// Views
import Paper from "../views/quections/Paper";
import SpotPaper from "../views/spotQuections/SpotPaper";
import Home from "../views/Home/Home";
import AboutUs from "../views/AboutUs";
import Contact from "../views/Contact";
import Index from "../views/PapersPage";
import UserDetailsForm from "../views/Forms/UserDetailForms/UserDetailsForm";
import Learners from "../views/Learners/Learners";
import DrivingSchool from "../views/DrivingSchool";
import AuthPage from "../AuthLearners/AuthPage";
import Admin from "../views/Admin/Admin";
import StudentProfile from "../views/Admin/ManageStudents/StudentProfile";
import Members from "../views/Admin/Members/Members";
import ManageStudents from "../views/Admin/ManageStudents/ManageStudents";
import EditProfile from "../views/Admin/EditProfile/EditProfile";
import AdminHome from "../views/Admin/AdminHome/AdminHome";
import EditOwnerDetails from "../views/Admin/EditProfile/EditOwnerDetails/EditOwnerDetails";
import EditLearnersDetails from "../views/Admin/EditProfile/EditLearnersDetails/EditLearnersDetails";
import GetUserDetailsForm from "../views/Forms/GetUserDetailsForm";
import PrivacyPolicy from "../views/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "../views/TermsAndConditions/TermsAndConditions";
import GetLearnersDetailsForm from "../views/Forms/GetLearnersDetailsForm";
import Academy from "../views/Academy/Academy";
import AcademyDetails from "../views/AcademyDetails/AcademyDetails";
import SingleUserDetails from "../views/Admin/Members/UserCard/SingleUserDetails";
import Videos from "../views/Videos";
import ReturnPolicy from "../views/ReturnPolicy";
import PDFViewerPage from "../views/PDFViewerPage";
import SubscriptionPage from "../views/SubscriptionPage";
import TrafficRules from "../views/TrafficRules";
import LearnersSchool from "../views/LearnersSchool";
import PaymentSuccessPage from "../views/SubscriptionPage/PaymentSuccessPage/PaymentSuccessPage";
import SinhalaHandBook from "../views/HandBooks/SInhalaHandBook";
import PayHereReturn from "../views/SubscriptionPage/PayHereReturn";
import PayHereCancel from "../views/SubscriptionPage/PayHereCancel";

const Router = () => {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {/* Public Pages with Layout */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />

            <Route
              path="/sri-lanka-driving-license-exam-papers"
              element={<Index />}
            />
            <Route path="/about-lanka-learners" element={<AboutUs />} />
            <Route path="/contact-lanka-learners" element={<Contact />} />
            <Route
              path="/find-and-register-driving-schools"
              element={<Learners />}
            />
            <Route path="/driving-license-video-guide" element={<Academy />} />
            <Route
              path="/traffic-rules-and-fines-sri-lanka"
              element={<TrafficRules />}
            />
            <Route path="/learners-school" element={<LearnersSchool />} />
            <Route path="/Privacy-Policy" element={<PrivacyPolicy />} />
            <Route
              path="/Terms-&-Conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/Return-Policy" element={<ReturnPolicy />} />
            <Route path="/userDetailsForm" element={<UserDetailsForm />} />
            <Route
              path="/new-user-details-form"
              element={<GetUserDetailsForm />}
            />
            <Route
              path="/new-learners-registation"
              element={<GetLearnersDetailsForm />}
            />
            <Route path="/academy-details" element={<AcademyDetails />} />
            <Route
              path="/drivingSchool/:schoolName"
              element={<DrivingSchool />}
            />
            <Route path="/driving-handbook" element={<PDFViewerPage />} />

            {/* Section-based Academy Routes */}
            <Route
              path="/driving-license-video-guide/online-class"
              element={<Academy initialSection="online-class" />}
            />
            <Route
              path="/driving-license-video-guide/personal-driving-instructor"
              element={<Academy initialSection="personal-driving-instructor" />}
            />
            <Route
              path="/academy-details/online-class"
              element={<AcademyDetails initialSection="online-class" />}
            />
            <Route
              path="/academy-details/personal-driving-instructor"
              element={
                <AcademyDetails initialSection="personal-driving-instructor" />
              }
            />

            <Route path="/subscription" element={<SubscriptionPage />} />
            <Route path="/success" element={<PaymentSuccessPage />} />
            <Route path="/payhere/return" element={<PayHereReturn />} />
            <Route path="/payhere/cancel" element={<PayHereCancel />} />
            <Route
              path="/read-driving-handbook"
              element={<SinhalaHandBook />}
            />
          </Route>

          {/* Auth Page - outside layout */}
          <Route path="/authPage" element={<AuthPage />} />
          <Route path="/paper" element={<Paper />} />
          <Route path="/spot-paper" element={<SpotPaper />} />
          <Route path="/videos" element={<Videos />} />

          {/* Admin Section - Protected, separate layout */}
          <Route path="/admin" element={<Admin />}>
            <Route index element={<AdminHome />} />
            <Route path="members" element={<Members />} />
            <Route path="manageStudent" element={<ManageStudents />} />
            <Route path="editProfile" element={<EditProfile />} />
            <Route
              path="editProfile/editOwnerDetails/:drivingSchoolId"
              element={<EditOwnerDetails />}
            />
            <Route
              path="editProfile/editLearnersDetails/:branchName"
              element={<EditLearnersDetails />}
            />
            <Route
              path="studentProfile/:memberID"
              element={<StudentProfile />}
            />
            <Route
              path="user-details/:userId"
              element={<SingleUserDetails />}
            />
          </Route>
        </Routes>
      </Suspense>
    );
};

export default Router;
